import { render, staticRenderFns } from "./viewChainSupplierProduct.vue?vue&type=template&id=90a3131c&scoped=true"
import script from "./viewChainSupplierProduct.vue?vue&type=script&lang=js"
export * from "./viewChainSupplierProduct.vue?vue&type=script&lang=js"
import style0 from "./viewChainSupplierProduct.vue?vue&type=style&index=0&id=90a3131c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a3131c",
  null
  
)

export default component.exports